///<reference path='../../typings/index.d.ts' />

module agi.expressions.card.utils{

    /**
     * A collection of utilites for transforming directions
     */
    export class TransformUtils{
        /**
         * Transform a direction from local space relative to the transform to global space
         * @param point 
         * @param transform 
         */
        public static transformDirection(point:PIXI.Point, transform:PIXI.Matrix) {
            var clone = transform.clone();
            clone.tx = 0;
            clone.ty = 0;
    
            return clone.apply(point);
        }

        /**
         * Transform a direction from global space to local space relative to the transform
         * @param point 
         * @param transform 
         */
        public static inverseTransformDirection(point:PIXI.Point, transform:PIXI.Matrix){
            var clone = transform.clone();
            clone.tx = 0;
            clone.ty = 0;
    
            return clone.applyInverse(point);
        }

        /**
         * Set the pivot of the object while maintaining it's visual position. Note that this means it's position WILL change, but it will not visually appear to move.
         * @param newPivot 
         * @param object 
         */
        public static setPivotAndMaintainVisualPosition(newPivot:PIXI.Point, object:PIXI.DisplayObject){
            //We'll need to be as up-to-date here as possible regarding object and object's parent's world transform!
            this.updateParentTransform(object);
            
            let pDelta = new PIXI.Point(newPivot.x - object.pivot.x, newPivot.y - object.pivot.y);
            object.pivot.copy(newPivot);
            let globalDelta = TransformUtils.transformDirection(pDelta, object.worldTransform);
            let parentLocalDelta = object.parent ? TransformUtils.inverseTransformDirection(globalDelta, object.parent.worldTransform) : globalDelta;
            object.position.x += parentLocalDelta.x;
            object.position.y += parentLocalDelta.y; 
        }

        /**
         * Sets pivot as the standard method does for object and for object's children (and their children) as well.
         * @see setPivotAndMaintainVisualPosition
         */
        public static setPivotAndMaintainVisualPositionRecursively(newPivot:PIXI.Point, object:PIXI.Container){
            let rec = (obj) => {
                this.setPivotAndMaintainVisualPosition(newPivot, obj);
                for (let child of obj.children){
                    rec(child);
                }
            }
            rec(object);
        }

        /**
         * Add a child to the root container, but make sure that the child does not change visual position.
         * @param parent 
         * @param child 
         */
        public static addChildAndMaintainVisualPosition(parent:PIXI.Container, child:PIXI.DisplayObject){
            this.updateParentTransform(child);
            let childParent = child.parent ? child.parent : child;
            let globalPos = childParent.toGlobal(child.position);

            parent.parent && parent.updateTransform();
            parent.addChild(child);
            child.position = parent.toLocal(globalPos);
        }

        private static updateParentTransform(child){
            if (child.parent)
            {
                if (child.parent.parent)
                    child.parent.updateTransform();
                else
                    child.updateTransform();
            }

        }
    }
}